import {
  Stack,
  Box,
  Text,
  ButtonLink,
  Heading,
  IconChevronLeft,
} from '@n26/nxd'
import { useLocaliseString } from '@hooks/useLocaliseString'
import { formatDate } from '@helpers/core/formatDate'
import { IconWithTextLink } from '@components/IconWithTextLink'
import { Markdown } from '@components/Markdown'
import { HorizontalRule } from '@components/HorizontalRule'
import type { AppLocales } from '@constants/i18n'
import type { PressReleasePickedItem } from '@cms/data/getPressReleaseArticle'

const PressRelease = ({
  item,
  locale,
  pressReleasesUrl,
}: {
  item: PressReleasePickedItem
  locale: AppLocales
  pressReleasesUrl: string
}) => {
  const localiseString = useLocaliseString()

  const { title, content, date, pressReleasePdf, pressReleaseFooter } =
    item || {}

  return (
    <Stack space='32'>
      <Box display='flex'>
        <IconWithTextLink
          data-testid='back-to-press-releases-button'
          text={localiseString('pressReleaseBackLinkLabel')}
          className='text-neutral-alternate hover:text-teal'
          url={pressReleasesUrl}
          StartIcon={IconChevronLeft}
        />
      </Box>

      <Stack space='16'>
        <time dateTime={date}>
          <Text color='neutral-alternate' variant='small'>
            {formatDate(date, locale)}
          </Text>
        </time>

        <Heading level={1} variant='large'>
          {title}
        </Heading>

        {content && (
          <>
            <Markdown source={content} />

            {pressReleaseFooter?.body && (
              <>
                <HorizontalRule />
                <Markdown source={pressReleaseFooter.body} />
              </>
            )}
          </>
        )}
      </Stack>
      {pressReleasePdf?.url && (
        <Box display='flex'>
          <ButtonLink href={pressReleasePdf.url}>
            {localiseString('pressReleaseDownloadPdf')}
          </ButtonLink>
        </Box>
      )}
    </Stack>
  )
}

export { PressRelease }
